import React from "react";
import { Chip } from "@mui/material";
import { statusSeverity } from "../utils/statusColors";

const PrivacyChip = ({ privacy }) => {
    const chipColor = statusSeverity("privacy", privacy);

    return (
        <Chip color={chipColor} size="small" variant="outlined" label={privacy} />
    );
}

export default PrivacyChip;